<template>
  <section id="file" class="slideDown">
    <div class="back" @click="back()">{{ $t('admin.resource.back') }}</div>
    <ClipperImage
      v-if="clipper"
      :image="clipper"
      @getImage="showThumb"
    ></ClipperImage>
    <div class="container">
      <div class="image">
        <img @click="addThumbnail" v-if="thumbnail" :src="thumbnail" />
        <div @click="addThumbnail" v-else class="addthumb">
          <div>
            <v-icon x-large>add</v-icon>
          </div>
          <div class="text">{{ $t('admin.resource.add_thumbnail') }}</div>
        </div>
        <input
          type="file"
          style="display: none"
          ref="thumbnail"
          accept="image/*"
          @change="onThumbnailPicked"
        />
      </div>

      <div class="content">
        <h3 class="title">
          <span v-if="file.id == -1">{{ $t('general.create') }}</span><span v-else>{{ $t('general.edit') }}</span
          ><span>{{ $t('admin.resource.resource') }}</span>
        </h3>

        <div class="details">
          <div class="subtitle">{{ $t('general.subtitle') }}</div>
          <v-form ref="form_resource" v-model="valid">
            <v-text-field
              v-model="file.name"
              :rules="requiredRules"
              :label="$t('general.name')"
              required
            ></v-text-field>
            <v-select
              v-model="file.category"
              :rules="requiredRules"
              :items="category"
              :label="$t('general.category_type')"
            ></v-select>
            <template v-if="file.category != undefined">
              <v-flex
                xs12
                class="text-xs-center text-sm-center text-md-center text-lg-center"
              >
                <!-- <img :src="imageUrl" height="150" v-if="fil"/> -->
                <v-text-field
                  :label="$t('admin.resource.select_resource')"
                  v-model="fileUrl"
                  prepend-icon="library_add"
                  :disabled="!!fileName"
                ></v-text-field>

                <div class="input">
                  <input
                    type="file"
                    name="resource_file"
                    id="resource_file"
                    ref="resource_file"
                    class="inputfile"
                    @change="onFilePicked"
                    :disabled="!!file.file"
                  />
                  <label v-if="fileName" for="resource_file">
                    <img class="icon" src="/img/file.jpg" />
                    {{ fileName }}
                  </label>
                  <label v-else for="resource_file">
                    <v-icon class="icon">upload</v-icon>
                    {{ $t('admin.resource.select_resource') }}
                  </label>
                  <v-icon
                    v-if="fileName"
                    class="icon delete"
                    color="#ba2b21"
                    @click="deleteFile(fileName)"
                    >delete</v-icon 
                  >
                </div>
                
                <div v-if="fileName" class="buttons preview-button">
                  <v-btn large color="success" @click="openPreview()">{{ $t('general.preview') }}</v-btn>
                </div>
                <input
                  type="file"
                  style="display: none"
                  ref="image"
                  accept="*"
                  @change="onFilePicked"
                />
              </v-flex>

              <!--<v-text-field v-model="file.url" :rules="requiredRules" label="URL en LSM" required></v-text-field>-->
              <v-text-field
                v-if="file.category < 4"
                v-model="file.reference"
                :label="$t('general.reference')"
              ></v-text-field>
              <v-text-field
                multi-line
                v-model="file.description"
                :label="$t('general.description')"
              ></v-text-field>
              <v-select
                v-if="file.category < 4 && market === 'ES'"
                v-model="file.lang"
                :rules="requiredRules"
                :items="languages"
                :label="$t('general.language')"
              ></v-select>
              <v-autocomplete
                v-if="file.category < 4"
                v-model="file.type"
                :items="types"
                :search-input.sync="search_type"
                hide-no-data
                :placeholder="$t('admin.resource.select_type')"
                :rules="requiredRules"
              ></v-autocomplete>
              <v-select
                v-model="file.status"
                :rules="requiredRules"
                :items="status"
                :label="$t('general.status')"
                :disabled="false"
              ></v-select>

              <v-switch
                v-if="market === 'PT'"
                class="filter switch"
                v-model="download"
                :label="$t('admin.resource.downloads')"
                inset
              ></v-switch>
              <div v-if="file.category < 4 || file.category == 5">
                <div class="subtitle">{{ $t('general.categories') }}</div>
                <div v-show="error_message" class="message error fadeIn">
                  {{ $t('admin.resource.categories_error') }}
                </div>
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('general.search_category')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  id="categories"
                  :rules="requiredRules"
                  :custom-filter="filterTable"
                  v-model="selected"
                  :headers="headers"
                  :items="sections"
                  class=""
                  :no-results-text="message_not_found"
                  :rows-per-page-items="rowsPerPage"
                  :search="search"
                  :pagination.sync="pagination"
                  :rows-per-page-text="message_rows_per_page"
                  select-all
                >
                  <!--<template v-slot:headers="props">
                        <tr>
                          <th width="50px">
                            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll " :class="['column sortable', pagination.descending ? 'desc' : 'asc', 'select' === pagination.sortBy ? 'active' : '']" ></v-checkbox>
                            <v-icon small @click="changeSort('select')">arrow_upward</v-icon>
                          </th>
                          <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                            @click="changeSort(header.value)"
                          >
                            <v-icon small>arrow_upward</v-icon>
                            {{ header.text }}
                          </th>
                        </tr>
                    </template>-->
                  <template v-slot:items="props">
                    <template v-if="props.item.level >= 0">
                      <tr>
                        <td>
                          <v-checkbox
                            v-model="props.selected"
                            primary
                            hide-details
                            :key="props.item.id"
                          ></v-checkbox>
                        </td>
                        <td></td>
                        <td style="text-align:left">
                          <div class="name">{{ props.item.name }}</div>
                          <div class="path">{{ props.item.path }}</div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </v-data-table>
              </div>

              <v-combobox
                multiple
                v-model="tagsArray"
                :label="$t('admin.resource.tags')"
                chips
                deletable-chips
                class="tag-input"
              >
              </v-combobox>

              <v-switch
                v-if="file.category < 3"
                v-model="file.budget"
                :label="$t('admin.resource.budget')"
              ></v-switch>
            </template>
          </v-form>
        </div>

        <div class="buttons">
          <v-btn large color="success" @click="save">{{ $t('general.save') }}</v-btn>
          <v-btn large color="cancel" @click="back">{{ $t('general.back') }}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '@/i18n'
import ClipperImage from "@/components/domain/admin/ClipperImage";

export default {
  props: {},
  components: { ClipperImage },
  data() {
    return {
      selected: [],
      valid: false,
      status: [
        { text: i18n.t('general.inactive'), value: "0" },
        { text: i18n.t('general.active'), value: "1" },
        { text: i18n.t('general.draft'), value: "2" }
      ],
      clipper: false,
      fileName: JSON.parse(
        JSON.stringify(this.$store.getters["files/getCurrentFile"])
      ).file,
      thumbnail: JSON.parse(
        JSON.stringify(this.$store.getters["files/getCurrentFile"])
      ).thumb,
      requiredRules: [v => !!v || i18n.t('general.obligatory_field')],
      headers: [
        { text: "", value: "selected", width: "30px", class: "condensed" },
        { text: i18n.t('general.name'), value: "name", width: "100%" }
      ],
      search: "",
      search_type: "",
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rowsPerPage: [10],
      pagination: {
        sortBy: false,
        descending: true
      },
      sectionTypes: {
        "1": { name: i18n.t('general.section_types.national') },
        "2": { name: i18n.t('general.section_types.local') }
      },
      category: [
        { text: i18n.t('admin.resource.categories.piece'), value: "3" },
        { text: i18n.t('admin.resource.categories.toolkit'), value: "4" },
        { text: i18n.t('admin.resource.categories.best_practice'), value: "5" }
      ],
      file: JSON.parse(
        JSON.stringify(this.$store.getters["files/getCurrentFile"])
      ),
      error_message: false
    };
  },
  created() {
    var id = this.file.id != -1 ? this.file.id : "add";
    this.$router.push({ name: "resources_edit", params: { id: id } });

    // Process tags safely - convert string to array for component
    if (this.file.tags && typeof this.file.tags === 'string') {
      this.file.tags = this.file.tags
        .split("|")
        .filter(tag => tag && tag.trim() !== "")
        .map(tag => tag.trim());
    } else if (!Array.isArray(this.file.tags)) {
      this.file.tags = [];
    }
    this.file.sections = this.file.sections || [];
    this.selected = this.file.sections;

    this.file.budget = this.file.budget == "1";

    if (this.market === 'PT') {
      this.file.lang = this.file.lang.id;
      if (this.file.download == null) {
        this.file.download = 1;
      }
    } else {
      if (this.file.lang && this.file.lang.id) {
        this.file.lang = this.file.lang.id;
      } else {
        const defaultLang = this.languages[0];
        if (defaultLang) {
          this.file.lang = defaultLang.value;
        }
      }
    }

    this.file.type = this.file.type.id;

    var self = this;
    this.$store.dispatch("files/loadCategories", {}).then(function() {
      self.$store.commit("files/selectCategory", false);
    });
  },
  computed: {
    languages() {
      var languages = ObjectToArray(this.$store.state.languages);
      var aLanguages = [];

      languages.forEach(lang => {
        if (this.market === 'ES' && lang.id !== 'L3VrYWUzY1kxUWViTTUzMHp3QnRSQT09') {
          aLanguages.push({ text: lang.fullname, value: lang.id });
        } else if (this.market === 'PT') {
          aLanguages.push({ text: lang.fullname, value: lang.id });
        }
      });
      return aLanguages;
    },

    sections() {
      if (this.file.category <= 3) this.file.category = "3";

      console.log(this.$store.getters["files/getCategories"]());
      var sections = ObjectToArray(
        JSON.parse(JSON.stringify(this.$store.getters["files/getCategories"]()))
      );
      var secCategory = parseInt(this.file.category);

      var aSections = [];
      sections.forEach(section => {
        var childs = ObjectToArray(section.childs);
        section.visible = true;
        section.childs = childs;
        section.level = parseInt(section.level);
        section.path = section.name;
        section.selected = false;
        if (
          section.level <= 2 && this.file.category == 5
            ? section.type == this.file.category
            : section.type != 5
        ) {
          if (
            (secCategory == 4 || secCategory == 5) &&
            section.level == secCategory
          ) {
            aSections.push(section);
          } else {
            aSections.push(section);
          }
        }
        childs.forEach(child => {
          child.visible = child.visible || false;
          var childs2 = ObjectToArray(child.childs);
          child.childs = childs2;
          child.level = parseInt(child.level);
          child.path = section.name + " > " + child.name;
          child.selected = false;
          if (
            child.level <= 2 && this.file.category == 5
              ? child.type == this.file.category
              : child.type != 5
          ) {
            if (
              (secCategory == 4 || secCategory == 5) &&
              section.level == secCategory
            ) {
              aSections.push(child);
            } else {
              aSections.push(child);
            }
          }
          childs2.forEach(child2 => {
            child2.visible = child2.visible || false;
            child2.level = parseInt(child2.level);
            child2.selected = false;
            child2.path =
              section.name + " > " + child.name + " > " + child2.name;
            if (
              child2.level <= 2 && this.file.category == 5
                ? child2.type == this.file.category
                : child2.type != 5
            ) {
              if (
                (secCategory == 4 || secCategory == 5) &&
                section.level == secCategory
              ) {
                aSections.push(child2);
              } else {
                aSections.push(child2);
              }
            }
          });
        });
      });
      return aSections;
    },

    types() {
      var types = ObjectToArray(this.$store.getters["files/getTypes"]);
      var aTypes = [];

      types.forEach(type => {
        aTypes.push({ text: type.name, value: type.id });
      });

      aTypes.sort(function(a, b) {
        if (a.text < b.text) return -1;
        else return 1;
      });

      return aTypes;
    },
    /* selected: {
      get: function(){
        console.log("SELECTED CHANGE");
        console.log(this.first_selection);
          return this.first_selection;
      },
      set: function( sections ){
        console.log( sections );
        this.file.sections = sections;
        console.log( this.file.sections );
      }
    } */
    market() {
      return this.$store.getters.getMarket;
    },

    tagsArray: {
      get() {
        return this.file && Array.isArray(this.file.tags) ? this.file.tags : [];
      },
      set(value) {
        if (this.file) {
          if (Array.isArray(value) && value.length > 0) {
            const cleanTags = value
              .filter(tag => tag && typeof tag === 'string' && tag.trim() !== '')
              .map(tag => tag.trim().replace(/\|/g, '')) 
              .filter((tag, index, arr) => tag !== '' && arr.indexOf(tag) === index);
            
            this.file.tags = cleanTags;
          } else {
            this.file.tags = [];
          }
        }
      }
    },
    fileUrl: {
      get() {
        return this.file.file ? this.file.file.name : "";
      },
      set(value) {
        this.file.file = value;
      }
    },
    download: {
      get() {
        if (this.file.download == null) return true;
        return this.file.download != 0;
      },
      set(value) {
        this.file.download = value ? 1 : 0;
      }
    }

  },
  methods: {
    back() {
      this.$store.commit("files/unsetCurrentFile");
      this.$router.push({ name: "resources" });
    },
    addThumbnail() {
      this.$refs.thumbnail.click();
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.fileName = files[0].name;
        this.file.file = files[0];
      } else {
        this.fileName = "";
      }
    },
    onThumbnailPicked(e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (this.clipper) URL.revokeObjectURL(this.clipper);
        this.clipper = window.URL.createObjectURL(e.target.files[0]);
      }
    },
    showThumb(image) {
      // console.log( image );
      this.clipper = false;
      this.thumbnail = image;

      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(",");
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      if (image) {
        this.file.thumb = dataURLtoFile(
          image,
          "thumb_" + moment().valueOf() + ".jpg"
        );
      }
    },
    save() {
      if (this.file.category < 4) {
        var sections = this.selected;
        var aSections = [];
        sections.forEach(section => {
          aSections.push(section.id);
        });
      } else if (this.file.category == 5) {
        var aSections = [];
        this.sections.forEach(section => {
          if (section.name == "Best Practices") {
            aSections.push(section.id);
          }
        });
        var sections = this.selected;
        sections.forEach(section => {
          aSections.push(section.id);
        });
        this.file.type = -1;
        if (this.market === 'ES') {
          this.file.lang = this.languages[0].value;
        } else if (this.market === 'PT') {
          this.file.lang = this.languages[2].value;
        }
      } else {
        var aSections = [];
        this.sections.forEach(section => {
          if (section.name == "Toolkits" && this.file.category == 4) {
            aSections.push(section.id);
          }
        });
        this.file.type = -1;
        if (this.market === 'ES') {
          this.file.lang = this.languages[0].value;
        } else if (this.market === 'PT') {
          this.file.lang = this.languages[2].value;
        }
      }

      this.file.sections = aSections;
      if (
        this.$refs.form_resource.validate() &&
        (this.file.category == 5 ||
          (this.file.category < 5 && this.file.thumb)) &&
        this.file.sections.length != 0
      ) {
        this.$overlay.loading();

        var self = this;

        this.file.url = this.file.name
          .normalize("NFD")
          .replace(/[^a-zA-Z0-9-_]/g, "")
          .replace(" ", "")
          .toLowerCase();
        if (this.$store.getters["files/existURLResource"](this.file.url)) {
          var n = 1;
          var url = this.file.url + "_" + n;
          while (this.$store.getters["files/existURLResource"](url)) {
            url = this.file.url + "_" + n;
            n += 1;
          }
          this.file.url = url;
        }

        this.$store
          .dispatch("files/uploadResource", this.file)
          .then(function() {
            self.$overlay.hide();
            self.$store.commit("files/unsetCurrentFile");
            self.$router.push({ name: "resources" });
          });
      } else if (this.file.sections.length == 0) {
        this.error_message = true;
      }
    },
    expand(id) {
      this.$store.commit("files/expandSection", id);
    },
    less(id) {
      this.$store.commit("files/lessSection", id);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else {
        var sections = this.sections;
        this.selected = sections.slice();
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    filterTable(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(item.name.toLowerCase().trim(), search.toLowerCase().trim()) ||
          filter(item.path.toLowerCase().trim(), search.toLowerCase().trim())
        ) {
          aItems.push(item);
          // } else {
          //   item.childs.forEach(child => {
          //     if (
          //       filter(child.name, search.toLowerCase()) ||
          //       filter(child.path, search.toLowerCase())
          //     ) {
          //       aItems.push(item);
          //     } else {
          // THIS IS WRONG (CONSOLE ERROR: i.childs.forEach is not a function)
          //       child.childs.forEach(child2 => {
          //         if (
          //           filter(child2.name, search.toLowerCase()) ||
          //           filter(child2.path, search.toLowerCase())
          //         ) {
          //           aItems.push(item);
          //         }
          //       });
          //     }
          //   });
        }
      });
      return aItems;
    },
    openPreview() {
      window.open(this.fileName, '_blank');
    },
    deleteFile(fileName) {
      this.fileName = "";
      this.file.file = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.child {
  border-top: 2px solid var(--main_color);
}
.child2 {
  border-top: 2px solid var(--secondary_color);
}
.separator {
  float: left;
  width: 30px;
  opacity: 0;
}
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  overflow: hidden;

  .image {
    width: 40%;
    float: left;
    padding: 0 40px;

    img,
    .addthumb {
      width: 95%;
      border: 1px solid #ccc;
      min-height: 250px;
      position: relative;
      cursor: pointer;
    }

    .addthumb div {
      width: 100%;
      display: block;
      top: 35%;
      position: absolute;
      text-align: center;
    }
    .addthumb .text {
      top: 55%;
    }
  }

  #categories {
    .name {
    }
    .path {
      font-size: 13px;
      color: #999;
    }
  }

  .content {
    width: 60%;
    float: left;
    text-align: left;
    padding: 0 25px;

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      margin: 20px 0;

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }

      .input {
        width: 100%;
        margin: 0 auto;
        display: flex;
        gap: 8px;
        align-items: center;

        .inputfile {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }

        .inputfile + label {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          flex: 1;
          cursor: pointer;
          padding: 8px 8px;
          background-color: rgba(0, 0, 0, 0.15);
          border-radius: 3px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }

        .inputfile:focus + label,
        .inputfile + label:hover {
        }

        .icon {
          display: flex;
          align-items: center;
          width: 25px;
          height: 25px;
          margin: 0;
          margin-right: 10px;
        }
        .delete {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          width: fit-content;
          margin: 0;
        }
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }

    .buttons {
      margin: 35px 0;
      &.preview-button {
        margin: 0px !important; 
      }

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid #ffbb0c;

          .icon {
            background: url(/img/download.svg) no-repeat center #ffbb0c;
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}
</style>
